import React, { useRef, useEffect } from "react";
import { PropTypes } from "prop-types";
import cx from "classnames";
import { findByType } from "../../utils";
import { SlideToggleContent } from "./SlideToggleContent";

const Toggle = () => null;
Toggle.displayName = "AccordionToggle";
const Panel = () => null;
Panel.displayName = "AccordionPanel";
const PanelCard = ({
	id,
	isOpen,
	focusedKey,
	onClick,
	onKeyDown,
	activeClassName,
	className,
	children,
	isFocused,
}) => {
	const ref = useRef(null);
	useEffect(() => {
		if (isFocused && ref.current !== null && id === focusedKey) {
			ref.current.focus();
		}
	}, [isFocused, focusedKey, id]);

	const renderToggle = () => {
		const toggle = findByType(children, Toggle);
		if (!toggle) {
			return null;
		}

		return (
			<a
				ref={ref}
				className={cx(toggle.props.className, isOpen && activeClassName)}
				aria-controls={id}
				aria-expanded={isOpen}
				aria-disabled={!isOpen}
				href={`#${id}`}
				id={`accordion${id}`}
				tabIndex={0}
				onClick={e => onClick(e, id)}
				onKeyDown={e => onKeyDown(e, id)}>
				{toggle.props.children.type || toggle.props.children.name
					? React.cloneElement(toggle.props.children, {
							isActive: isOpen,
					  })
					: toggle.props.children}
			</a>
		);
	};

	const renderPanel = () => {
		const panel = findByType(children, Panel);
		if (!panel) {
			return null;
		}
		return (
			<SlideToggleContent id={id} className={panel.props.className} isVisible={isOpen}>
				{panel.props.children}
			</SlideToggleContent>
		);
	};
	return (
		<div className={className} accordion-section="wrapper">
			{renderToggle()}
			{renderPanel()}
		</div>
	);
};
PanelCard.displayName = "PanelCard";

PanelCard.Toggle = Toggle;
PanelCard.Panel = Panel;
PanelCard.propTypes = {
	isOpen: PropTypes.bool,
	onClick: PropTypes.func,
	onKeyDown: PropTypes.func,
	activeClassName: PropTypes.string,
	className: PropTypes.string,
	id: PropTypes.string,
	focusedKey: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	isFocused: PropTypes.bool,
};

PanelCard.defaultProps = {
	isOpen: false,
	onClick: null,
	onKeyDown: null,
	activeClassName: "",
	className: undefined,
	id: "",
	focusedKey: "",
	isFocused: false,
};

export default PanelCard;
export { PanelCard };
